import { filter } from 'lodash/fp';

import { PrivateOffer } from 'stores/privateOffers/typings';

export const filterByQuery = (
  query = '',
): ((t: PrivateOffer[]) => PrivateOffer[]) =>
  filter((r) => JSON.stringify(r).toLowerCase().includes(query.toLowerCase()));
